import FilterPills from "@/components/FilterPills";

export const EMPTY_TASK_FILTER = { view: "active", status: "", overdue: false };

const todayIso = () => new Date().toISOString().slice(0, 10);

export function applyTaskFilter(tasks, f, doneStatus = "complete") {
  return tasks.filter(t =>
    (f.view === "all" || (f.view === "archived" ? !!t.archived : !t.archived))
    && (!f.status || t.status === f.status)
    && (!f.overdue || (t.due_date && t.due_date.slice(0, 10) < todayIso() && t.status !== doneStatus)));
}

export default function TaskFilterBar({ tasks, value, onChange, statuses, testid = "task-filter" }) {
  const n = (view) => tasks.filter(t => view === "all" || (view === "archived" ? !!t.archived : !t.archived)).length;
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={testid}>
      <FilterPills testid={`${testid}-view`} value={value.view} onChange={(v) => onChange({ ...value, view: v })}
        options={[
          { k: "active", label: `Active (${n("active")})` },
          { k: "archived", label: `Archived (${n("archived")})` },
          { k: "all", label: "All" },
        ]} />
      <select value={value.status} onChange={(e) => onChange({ ...value, status: e.target.value })}
        data-testid={`${testid}-status`} className="px-3 py-2 text-xs">
        <option value="">Any status</option>
        {statuses.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
      </select>
      <label className="label flex items-center gap-1 cursor-pointer">
        <input type="checkbox" checked={value.overdue} data-testid={`${testid}-overdue`}
          onChange={(e) => onChange({ ...value, overdue: e.target.checked })} /> Overdue only
      </label>
    </div>
  );
}
